import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export function makeMatchSelectValueValidation(errorMsg: string, getMatchingValue: () => string | undefined) {
  return (activeSelectOption: ISelectOption) => {
    const matchingValue = getMatchingValue();

    return matchingValue && activeSelectOption?.value === matchingValue ? errorMsg : undefined;
  };
}
